import React, { useState } from 'react';
import { OURWARE_NAME, OURWARE_URL } from '../lib/communityOs';

const scrollToCommunityOS = (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  const target = document.getElementById('community-os-title');
  if (target) {
    const navHeight = document.querySelector('header')?.offsetHeight || 0;
    const bannerHeight = 36;
    const top = target.getBoundingClientRect().top + window.pageYOffset - navHeight - bannerHeight;
    window.scrollTo({ top, behavior: 'smooth' });
  }
};

const About: React.FC = () => {
  const [showValueProjection, setShowValueProjection] = useState(false);

  return (
    <>
    <section 
      className="w-full relative" 
      style={{ 
        paddingTop: '24px', 
        paddingBottom: '48px', 
        marginTop: '0px'
      }}
    >
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: 'url(/images/Xaos_fractal_22.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          backgroundRepeat: 'no-repeat'
        }}
      ></div>
      <div className="absolute inset-0 bg-gray-400 bg-opacity-90"></div>
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column - How It Works Table */}
          <div className="space-y-6 px-4 sm:px-8 md:px-12 lg:pl-20 lg:pr-8 py-8">
            <h2 className="font-bold text-xl sm:text-2xl" style={{ color: '#000000' }}>How It Works</h2>
            
            <div className="w-full text-[10px] sm:text-xs mt-4">
              <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-4 pb-1 border-b border-gray-400">
                <div className="col-span-2 sm:col-span-1 text-left font-semibold text-black">Parameter</div>
                <div className="col-span-3 sm:col-span-3 text-left font-semibold text-black">Details</div>
              </div>
              <div className="divide-y divide-gray-300 text-black">
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-4 py-2">
                  <div className="col-span-2 sm:col-span-1 font-semibold leading-tight">Credits</div>
                  <div className="col-span-3 sm:col-span-3 leading-relaxed">Experience Keys include credit tokens priced at $1 USDC each at creation, with tiers based on credits-per-night. Round Robin priority is set by creation order. Credits renew annually for in-platform use and are burned if unused. They can be traded between members at market value, but are only created at launch and annually, in limited quantities based on number of units.</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-4 py-2">
                  <div className="col-span-2 sm:col-span-1 font-semibold leading-tight">Credits Per Night</div>
                  <div className="col-span-3 sm:col-span-3 leading-relaxed">The average nightly rate is fixed at launch, with minor variations based on room size or bed count. Credits are valid across all properties, though nightly cost will vary by location. Tourist taxes and cleaning fees vary by location, but credits per night remains ever constant. No monthly maintenance fees!</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-4 py-2">
                  <div className="col-span-2 sm:col-span-1 font-semibold leading-tight">Credit Merging</div>
                  <div className="col-span-3 sm:col-span-3 leading-relaxed">All Credits have a Round Robin #attached to them. A weighted average applies when you merge credits together.</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-4 py-2">
                  <div className="col-span-2 sm:col-span-1 font-semibold leading-tight">Round-Robin System</div>
                  <div className="col-span-3 sm:col-span-3 leading-relaxed">Reservation access is distributed using a round-robin queue that moves every year so all get first place in turns. Credits have place in line metadata that changes each year.</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-4 py-2">
                  <div className="col-span-2 sm:col-span-1 font-semibold leading-tight">Annual Timeline</div>
                  <div className="col-span-3 sm:col-span-3 leading-relaxed">
                    <strong>Jan 1:</strong> Credits replenished based on initial purchase tier<br />
                    <strong>Jan 8 – May 31:</strong> Buy, sell, trade, and merge credits<br />
                    <strong>June 1 – June 30:</strong> Make Reservation Key season<br />
                    <strong>June 30:</strong> Round Robin reservations end. Credits all equal.<br />
                    First come first serve.<br />
                    <strong>Dec 31:</strong> Last day of usage year, all credits burned
                  </div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-4 py-2">
                  <div className="col-span-2 sm:col-span-1 font-semibold leading-tight">Buy, Sell or Donate Credits</div>
                  <div className="col-span-3 sm:col-span-3 leading-relaxed">Trade or merge credits before June 1; donate to support the DAO</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-4 py-2">
                  <div className="col-span-2 sm:col-span-1 font-semibold leading-tight">Governance</div>
                  <div className="col-span-3 sm:col-span-3 leading-relaxed">Experience Key holders vote on proposals; your annual credit balance = voting weight</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-4 py-2">
                  <div className="col-span-2 sm:col-span-1 font-semibold leading-tight">DAO & Legal Structure</div>
                  <div className="col-span-3 sm:col-span-3 leading-relaxed">Born Free's on-chain DAO provides advisory input and community sentiment to a Social Purpose Corporation (SPC) that interfaces with legacy systems like contracts, banks, and property records. The SPC provides legal protection and ensures compliance, while considering DAO community input as a barometer of member preferences. All DAO activity remains transparent and on-chain for community visibility.</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Real World Assets & Utility */}
          <div className="space-y-2 relative px-4 sm:px-8 md:px-12 lg:pl-8 lg:pr-20 py-8">
            <h2 className="font-bold text-xl sm:text-2xl" style={{ color: '#000000' }}>Real World Assets & Utility</h2>
            
            <p className="text-sm" style={{ color: '#000000', lineHeight: '1.5' }}>
              The DAO supports a wide range of community-driven projects, including immersive events, sustainable products, media, and shared spaces. Each Key has its own credit cost, and as the DAO grows, those costs may decrease over time. While property value increases are an external effect driven by inflation, they can also serve to benefit the community in the long term.
            </p>
            
            <div className="leading-relaxed">
              <div className="space-y-2">
                <div className="flex items-start">
                  <span className="text-black" style={{ marginRight: '12px', minWidth: '16px' }}>•</span>
                  <span className="text-sm" style={{ color: '#000000', lineHeight: '1.5' }}>Unique Keys represent real life launchpads for community projects, properties, events, or any special purpose. Projects can be virtually anything anywhere with a community backing it up.</span>
                </div>
                
                <div className="flex items-start">
                  <span className="text-black" style={{ marginRight: '12px', minWidth: '16px' }}>•</span>
                  <span className="text-sm" style={{ color: '#000000', lineHeight: '1.5' }}>We connect members together towards common causes. As our network expands so does our impact. All benefits flow back to the community. People before profits is our mantra.</span>
                </div>
                
                <div className="flex items-start">
                  <span className="text-black" style={{ marginRight: '12px', minWidth: '16px' }}>•</span>
                  <span className="text-sm" style={{ color: '#000000', lineHeight: '1.5' }}>IRL (In Real Life) consequences clearly defined and managed by AI analysis and community guidance. Be a trailblazer by joining the DAO - Decentralized Autonomous Organization.</span>
                </div>
              </div>
            </div>
            
                        {/* World Globe */}
            <div className="flex justify-center" style={{ marginTop: '48px' }}>
              <img 
                src="/images/world-1301744.png" 
                alt="World Globe" 
                loading="lazy"
                className="w-48 h-48 sm:w-60 sm:h-60 md:w-72 md:h-72"
                style={{ willChange: 'auto' }}
              />
            </div>

          </div>
        </div>
      </div>
    </section>

    {/* Why We Built This Section */}
    <section 
      className="w-full text-white relative" 
      style={{ 
        paddingTop: '96px', 
        paddingBottom: '96px',
        backgroundImage: 'url(/images/fractals-2042298_1920.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Semi-transparent overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-85"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column - Content */}
          <div className="space-y-6" style={{ paddingLeft: '80px', paddingRight: '32px', paddingTop: '32px', paddingBottom: '32px' }}>
            <div className="space-y-6">
              <h2 className="font-bold text-gray-300" style={{ fontSize: '3rem' }}>Why?</h2>
              
              <p className="text-gray-300 text-sm leading-relaxed">
                We designed this platform with one guiding principle: maximize value for the community. Every element—pricing, credit systems, access, and governance—was carefully crafted to be as efficient, inclusive, and beneficial as possible. We iterated relentlessly, and we'll continue to optimize with input from our members.
              </p>
              
              <p className="text-gray-300 text-sm leading-relaxed">
                We believe in the power of collective wisdom, and cooperation instead of competition. By shifting the focus from profit extraction to shared benefit, we've created a system that challenges traditional models and shows what's possible when people collaborate using blockchain technology.
              </p>
              
              <p className="text-gray-300 text-sm leading-relaxed">
                This is more than a platform—it's a framework for cooperation, where members can safely buy, sell, and explore the world, with trust built into every interaction.
              </p>
              
              <div style={{ width: '48px', height: '2px', backgroundColor: '#a5acb3', margin: '24px 0' }}></div>
            </div>
          </div>

          {/* Right Column - Numbers Text */}
          <div className="space-y-6" style={{ paddingLeft: '32px', paddingRight: '80px', paddingTop: '32px', paddingBottom: '32px' }}>
            {/* Numbers section */}
            <div className="space-y-4">
              <h3 className="font-bold text-blue-400" style={{ fontSize: '1.25rem' }}>The Numbers Speak for Themselves</h3>
              
              <p className="text-gray-300 text-sm leading-relaxed">
                BornFree Keys are designed to deliver consistent access, utility, and member benefits through renewable credits, reservation opportunities, and participation in community governance. After the one-time creation cost, members receive credits annually that can be used across a growing network of experiences.
              </p>
              
              <p className="text-gray-300 text-sm leading-relaxed">
                Unlike traditional models that prioritize extraction, our platform is built around shared access and transparent contribution—empowering members through a flexible, use-based system that reflects real-world value without financial speculation.
              </p>
              
              <p className="text-gray-300 text-sm leading-relaxed">
                We believe this model of fair, utility-driven participation will redefine how communities engage with shared assets. This collaborative approach will soon become the norm—and someday, we'll look back at extractive systems as relics of a past era.
              </p>
              
              {/* How Keys Deliver Lasting Utility Dropdown */}
              <div className="mt-8">
                <button 
                  onClick={() => setShowValueProjection(!showValueProjection)}
                  className="inline-flex items-center text-blue-400 hover:text-blue-300 font-medium text-sm transition-colors duration-200"
                >
                  How Keys Deliver Lasting Utility
                  <svg 
                    className={`ml-2 w-4 h-4 transform transition-transform duration-200 ${showValueProjection ? 'rotate-180' : ''}`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {showValueProjection && (
                  <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-4">
                    <div className="bg-black bg-opacity-90 rounded-lg border border-gray-600 max-w-6xl w-full max-h-[90vh] overflow-y-auto">
                      <div className="p-6">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                          {/* Left Column - Image */}
                          <div className="flex justify-center items-center h-full">
                            <img 
                              src="/images/Born Free Credits-GoodAsGold.png" 
                              alt="Born Free Credits - Good As Gold" 
                              className="w-full h-auto rounded-lg shadow-lg object-contain"
                            />
                          </div>
                          
                          {/* Right Column - Content */}
                          <div className="space-y-4">
                            <p className="text-gray-300 text-sm leading-relaxed">
                              Imagine a member mints a Key that includes 20,000 credits. With an average stay costing 1,000 credits per night, that provides 20 nights of access annually. Over 20 years, that adds up to:
                            </p>
                            
                            <ul className="text-gray-300 text-sm leading-relaxed ml-4">
                              <li>• 400 nights of access (20 nights/year)</li>
                              <li>• Credits renew annually, creating a reliable system for long-term use</li>
                              <li>• As lodging prices rise over time, members continue receiving credits without escalating nightly rates. Tourist taxes or external factors may mean small fee increases, but the base nightly credit rate remains constant.</li>
                            </ul>
                            
                            <p className="text-gray-300 text-sm leading-relaxed">
                              In addition:
                            </p>
                            
                            <ul className="text-gray-300 text-sm leading-relaxed ml-4">
                              <li>• Keys may be sold within the platform under seasonal pricing guidelines</li>
                              <li>• Unused credits may be exchanged with other members during designated trade windows</li>
                              <li>• Members benefit from predictable access, transparent rules, and a platform designed around fairness—not speculation</li>
                            </ul>
                            
                            <p className="text-gray-300 text-sm leading-relaxed">
                              This approach offers long-term planning, consistent access, and community-first governance—without the volatility of traditional financial systems.
                            </p>
                          </div>
                        </div>
                        
                        {/* Close button */}
                        <div className="flex justify-end mt-6">
                          <button 
                            onClick={() => setShowValueProjection(false)}
                            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-gray-300 text-sm rounded-lg transition-colors duration-200"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-gray-600 max-w-2xl mx-auto text-center px-4 sm:px-8">
          <h3 className="font-bold text-blue-300 text-xl sm:text-2xl mb-2">Community Operating Systems</h3>
          <p data-testid="ourware-teaser" className="text-gray-400 text-xs sm:text-sm leading-relaxed mb-3">
            BornFree is part of{' '}
            <a
              href={OURWARE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="ourware-teaser-outbound"
              className="text-blue-400 hover:text-blue-300 font-medium"
            >
              {OURWARE_NAME}
            </a>
            , the organization that supports the development of community operating systems. BornFree is more than properties—we are building a fair, secure, open-source substrate where communities thrive with transparency, alongside partners advancing human sovereignty, privacy and freedom. See our other projects growing now.
          </p>
          <a
            href="#community-os-title"
            onClick={scrollToCommunityOS}
            className="inline-flex items-center text-blue-400 hover:text-blue-300 font-medium text-xs sm:text-sm transition-colors duration-200"
          >
            Learn more
            <svg className="ml-1 w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
    </>
  );
};

export default About; 